/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

// Style preference for leading underscores.
// tslint:disable:strip-private-property-underscore

import {html, LitElement, TemplateResult} from 'derivita/third_party/lit/packages/lit/src/index';
import {customElement} from 'derivita/third_party/lit/packages/lit/src/decorators';

import {styles} from './mwc-icon-host.css';

/** @soyCompatible */
@customElement('mwc-icon')
export class Icon extends LitElement {
  static override styles = [styles];

  /** @soyTemplate */
  protected override render(): TemplateResult {
    return html`<span><slot></slot></span>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mwc-icon': Icon;
  }
}
